/**
 * @file Back orders list page.
 */



import React from "react";
import { backOrderColumns } from "../../helpers/constants/constants";
import PagedSortableTable from "../table/PagedSortableTable";
import BackOrderList from "./BackOrderList";
import BackOrderDialog from "./BackOrderDialog";
import PageTitle from "../general/PageTitle";
import DashboardLink from "../general/links/DashboardLink";
import CurrentPage from "../general/links/CurrentPage";
import { TableCell } from "@mui/material";



/**
 * Renders the Back Orders page: a paginated, sortable, filterable table of deliveries.
 *
 * Layout:
 * - Page title and breadcrumb links: Dashboard > Backorders.
 * - A `PagedSortableTable` that fetches from `/backorders`
 *   (ViewBackOrders on the backend) and handles paging, sorting and filtering.
 *   It uses:
 *   - `backOrderColumns` for the column headers.
 *   - `BackOrderList` to render the rows.
 *   - `BackOrderDialog` as the filter dialog (date range and customer).
 *   - An extra "Details" header cell for the column holding each row's Details button.
 *
 * Takes no props.
 *
 * @returns {JSX.Element} The back orders page.
 */
function BackOrders() {
  return (
    <React.Fragment>
      {/* Title */}
      <PageTitle title={"Back Orders"} />
      {/* Link */}
      <div style={{ display: "flex" }}>
        <DashboardLink />
        <CurrentPage currentPage={"Backorders"} />
      </div>
      {/* Table */}
      <PagedSortableTable
        baseUrl={"/backorders"}
        columns={backOrderColumns}
        title="Back Orders"
        BodyComponent={BackOrderList}
        DialogComponent={BackOrderDialog}
        extra={<TableCell>Details</TableCell>}
      />
    </React.Fragment>
  );
}

export default BackOrders;